import SolutionsData from 'components/SolutionsData/SolutionsData'

const Data = () => {
  return <SolutionsData />
}

export default Data
